import React, { useEffect, useState } from "react";

import Select from "react-select";
import DateRange2 from "../../Component/DateRange/DateRange2";
import SubmitButton from "../../Component/SubmitButton";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import { useNavigate } from "react-router-dom";
import CommonPopup from "../../Component/CommonPopup";
import { PRIMARY_COLOR } from "../../Services/Colors";

const AnnounceResult = () => {

  const { kv, set } = useStoreKv();
  const [lotDraw, setLotDraw] = useState("");

  const DEFAULT_LOT_OPTIONS = [
    { value: "Dear", label: "Dear" },
    { value: "Kerala", label: "Kerala" },
  ];


  const DEFAULT_TIME_OPTIONS_DEAR = [
    { value: "1 PM", label: "1 PM", game_id: 1 },
    { value: "6 PM", label: "6 PM", game_id: 3 },
    { value: "8 PM", label: "8 PM", game_id: 4 },
  ];

  const DEFAULT_TIME_OPTIONS_KERALA = [
    { value: "3 PM", label: "3 PM", game_id: 2 },
  ];

 const getLocalDateString = (date = new Date()) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  
  const [timeDraw, setTimeDraw] = useState(null);
  const [resultNumber, setResultNumber] = useState(["", "", "", ""]);
  const [drawDate, setDrawDate] = useState(getLocalDateString());
  const [popup, setPopup] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [timeOptions, setTimeOptions] = useState([]);
  const [lotOptions, setLotOptions] = useState(kv.lotOptions || DEFAULT_LOT_OPTIONS);
  const [selectedTimeId, setSelectedTimeId] = useState(null);

  const [selectedLotData, setSelectedLotData] = useState([]);
  const [gameId, setGameId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!lotDraw) return;

    setTimeOptions(
      lotDraw?.value === 'Kerala'
        ? DEFAULT_TIME_OPTIONS_KERALA
        : DEFAULT_TIME_OPTIONS_DEAR
    );
  }, [lotDraw]);


  //   console.log("lotDrawcccc", lotDraw);


  // ⭐ Backup data for Edit
  const [backupData, setBackupData] = useState(null);

  //   console.log("backupData", backupData);


 

  const getList = async () => {
    if (!drawDate) return;

    try {
      const res = await get(`${URLS.REPORTDRAW}?date=${drawDate}`);

      if (res?.status === "success" && res?.data) {
        const data = res.data;
        let formatted = [];
        setSelectedLotData(data);

        if (data.some(i => i.name.toLowerCase().startsWith("dear"))) {
          formatted.push({ value: "Dear", label: "Dear" });
        }

        if (data.some(i => i.name.toLowerCase() === "kerala")) {
          formatted.push({ value: "Kerala", label: "Kerala" });
        }


        setLotOptions(formatted);
        set('lotOptions', formatted);
        if (formatted.length === 1) setLotDraw(formatted[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getList();
  }, [drawDate]);

  useEffect(() => {
    if (!lotDraw?.value) {
      setTimeOptions([]);
      return;
    }

    const fetchTimes = async () => {
      try {
        if (!selectedLotData || selectedLotData.length === 0) {
          setTimeOptions(lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
          set('lotTimeOptions', lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
          return;
        }

        const lowerLot = lotDraw.value?.toLowerCase();
        const filtered = selectedLotData
          .filter((item) => {
            const name = item.name.toLowerCase();

            if (lowerLot === "dear") return name.startsWith("dear");
            if (lowerLot === "kerala") return name.includes("kerala");
            return false;
          })
          .map((item) => ({
            value: item.lot_time,
            label: item.lot_time,
            id: item.id,
            game_id: item.game_id,
          }));

        if (filtered.length > 0) {
          setTimeOptions(filtered);
          set('lotTimeOptions', filtered);
        } else {
          setTimeOptions(lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
          set('lotTimeOptions', lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
        }
        //         console.log("Filtered Time Options:", filtered);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTimes();
  }, [lotDraw, drawDate, selectedLotData]);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    const arr = value.split("");
    while (arr.length < 4) arr.push("");
    setResultNumber(arr);
  };

  const handleCheckResult = () => {
    let newErrors = {};

    if (!lotDraw) newErrors.lot = "Please select Lot Name";
    if (!timeDraw) newErrors.time = "Please select Time";
    if (resultNumber.join("").length !== 4)
      newErrors.resultNumber = "Please enter 4 digits";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setShowResult(false);
      return;
    }

    // ⭐ Save backup before clearing
    setBackupData({
      drawDate,
      lotDraw,
      timeDraw,
      resultNumber,
    });

    setShowResult(true);

    // ⭐ Clear fields for UI reset
    setDrawDate(null);
    setLotDraw("");
    setResultNumber(["", "", "", ""]);
    setTimeDraw(null);
  };

  const handleEdit = () => {
    if (!backupData) return;

    // ⭐ Restore backup data
    setDrawDate(backupData.drawDate);
    setLotDraw(backupData.lotDraw);
    setTimeDraw(backupData.timeDraw);
    setResultNumber(backupData.resultNumber);

    setShowResult(false);
  };

  //   console.log("resultNumber", resultNumber);


  const handleAnnounceResult = async () => {

    const postId = selectedLotData.find(
      item => item.game_id === gameId
    )?.id;

    const id = selectedTimeId || postId;

    const postData = {
      id: id,
      winning_number: backupData?.resultNumber.join("")
    }

    setLoading(true);
    const res = await post(URLS.RESULTANNOUNCE, postData);

    if (res.status === "success") {
      Toast(res.message || "Result Announced Successfully");
      setDrawDate(null);
      setLotDraw("");
      setShowResult(false);
      setResultNumber(["", "", "", ""]);
      setTimeDraw(null);
      setPopup(false);
      navigate("/overall-result");
    }
    setLoading(false);
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      border: `1px solid ${PRIMARY_COLOR}`,
      border: `1px solid ${state.isFocused || state.hasValue ? PRIMARY_COLOR : `${PRIMARY_COLOR}`}`,
      boxShadow: state.isFocused
        ? "transparent"
        : "0 0 0 1px #dffffd66",
      "&:hover": {
        border: `1px solid ${PRIMARY_COLOR}`,
      },
      backgroundColor: "#F0EDE6",
      minHeight: 51,
      padding: "3px 10px",
      fontFamily: state.isSelected ? "f3" : "f2",
      color: PRIMARY_COLOR,
    }),

    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "transparent"
        : state.isFocused
          ? "transparent"
          : "transparent",
      fontFamily: "f2",
      color: state.isSelected
        ? PRIMARY_COLOR
        : PRIMARY_COLOR,
      cursor: "pointer",
      ":active": {
        backgroundColor: `${PRIMARY_COLOR}33`,
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: PRIMARY_COLOR,
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: PRIMARY_COLOR,
      "&:hover": {
        color: PRIMARY_COLOR,
      },
    }),
  };


  return (
    <div className="dashRightView ">
      <div style={{ paddingTop: 0 }} className="container_overall">

        <div className="announcement_date mb-3 col-md-5">
          <DateRange2 selectedDate={drawDate} setSelectedDate={setDrawDate} />
        </div>

        {/* LOT */}
        <div className="my-2 pb-2 col-md-5">
          <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Lot Name</label>
          <Select
            className="location-search"
            options={lotOptions}
            value={lotDraw}
            onChange={(selected) => {
              setLotDraw(selected);
              setTimeDraw(null);
              setSelectedTimeId(null);
            }}
            placeholder="Select Lot"
            isDisabled={!drawDate}
            styles={customStyles}
            isSearchable={false}
            noOptionsMessage={() => ""}
          />
          {errors.lot && <p className="err">{errors.lot}</p>}
        </div>

        {/* TIME */}
        <div className="my-2 pb-2 col-md-5">
          <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Time</label>
          <Select
            className="location-search"
            value={timeDraw}
            onChange={(selected) => {
              setTimeDraw(selected);
              setSelectedTimeId(selected.id);
              setGameId(selected.game_id);
            }}
            options={timeOptions}
            isDisabled={!lotDraw}
            placeholder="Select Time"
            styles={customStyles}
            isSearchable={false}
            noOptionsMessage={() => ""}
          />
          {errors.time && <p className="err">{errors.time}</p>}
        </div>

        {/* RESULT NUMBER */}
        <div className="my-2 pb-2 col-md-5">
          <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Result Number</label>
          <input
            className="input-box placholdercolorchanges2"
            type="number"
            value={resultNumber.join("")}
            onChange={handleChange}
            maxLength={4}
            placeholder="Enter Result Number"
          />
          {errors.resultNumber && <p className="err">{errors.resultNumber}</p>}
        </div>

        <div className="my-3 col-md-5">
          {/* <button className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white" onClick={handleCheckResult}>
            Check Result
          </button> */}
          <SubmitButton
            title="Check Result"
            onClick={handleCheckResult}
            isFormValid={false}
          />
        </div>

        {/* PREVIEW BOX */}
        {showResult && (
          <div className=" col-md-5">
            <div className="d-flex ac-jb">
              <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary">Check Result</label>
              <button className="f3 fs-sm-8 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15 edit1-btn2" onClick={handleEdit}>Edit</button>
            </div>

            <div
              style={{ backgroundColor: "#F0EDE6", borderRadius: 20 }}
              className="check_result border shadow-sm">
              <div className="d-flex ac-jb my-2">
                <h4 className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">Date</h4>
                <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">
                  {new Date(backupData?.drawDate)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                </p>
              </div>

              <div className="d-flex ac-jb my-2">
                <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">Lot Name</p>
                <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">{backupData?.lotDraw?.label}</p>
              </div>

              <div className="d-flex ac-jb my-2">
                <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">Time</p>
                <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">{backupData?.timeDraw?.label}</p>
              </div>

              <div className="d-flex ac-jb">
                <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">Result Number</p>
                <div className="d-flex gap-2">
                  {backupData?.resultNumber?.map((n, i) => (
                    <input
                      key={i}
                      value={n}
                      readOnly
                      className="result-input f3 text-center fs-xs-16 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-15 fs-xxl-20 sec placholdercolorchanges2"
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: 30,
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* <button
             
              onClick={() => setPopup(true)}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              Announce Result
            </button> */}

            <div style={{ marginBottom: 80, marginTop: 20 }}>
              <SubmitButton
                title="Announce Result"
                onClick={() => setPopup(true)}
                isFormValid={false}
              />
            </div>
          </div>
        )}
      </div>

      {/* {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Are you sure you want to Announce Result?
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
              <button onClick={() => { setPopup(false) }} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleAnnounceResult}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loading ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : 'Yes'}

              </button>
            </div>
          </div>
        </div>
      )} */}
      <CommonPopup
        isOpen={popup}
        message="Are you sure you want to Announce Result?"
        onClose={() => { setPopup(false) }}
        onConfirm={handleAnnounceResult}
        loading={loading}
      />
    </div>
  );
};

export default AnnounceResult;
